import { API } from "aws-amplify";
import 'containers/common/Detail.css';
import React, { Component } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
// First way to import
import { PacmanLoader } from 'react-spinners';
import 'react-table/react-table.css';





export default class TextPreview extends Component {
    constructor(props) {
        super(props);


        this.state = {
            isLoading: null,
            text: null,
            filter: {propertyid: this.props.match.params.propertyid, text: this.props.location.search.replace("?propertyid=", "")},
			property_id : this.props.match.params.propertyid
        };



       

    }

    

    async componentWillUnmount() {
       
     
    }

  
    async componentDidMount() {
        

        try {
            this.setState({ isLoading: true });   
			
        	
            await this.getText(this.state.filter);
            console.log(this.state.text);

            document.title = this.state.property_id+" Text preview" ;




            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }


    


    //Call API
    

    getText(filter) {
    	try {
    		API.get("colin", `/properties/${this.state.property_id}/text`, { 'queryStringParameters': filter }).then((text) => {
    			if (text) {
    				this.setState(state => ({ text }));
    			}
    		});
    	}
    	catch{
    		console.log("Error getting text");
    	}
    }



    render() {
        return (
            <div className="preview">
                {this.state.isLoading &&
					<div className="outer-div"><div className='sweet-loading inner-div' >
						<PacmanLoader
						css="display: block;
						margin: 0 auto;
						border-color: red"
						sizeUnit={"px"}
						size={20}
						color={'#e03c31'}
						loading={this.state.isLoading}
					/>
					</div> 
				</div>}
               
						{this.state.text  && this.props.isAuthenticated && !this.state.isLoading &&
							<Row>
							<Col>
				<div className="text">
					{this.state.text.length>0 &&
						<div>
						<Button onClick={() => window.print()}>Print</Button>

                                <Card><Card.Body>
						<Row>
							<Col>						
								<div className="BuildingText">
									<h5>Building Text</h5>
                                                {this.state.text[0].building_text}

								</div>
							</Col>
						</Row>
								</Card.Body></Card>
				<Card><Card.Body>
				<Row><Col>
				<div className="ProposalText">
					<h5>Proposal Text</h5>
				{this.state.text[0].development_proposal_text}
				</div>
				</Col></Row>
				</Card.Body></Card>
				<Card><Card.Body>
				<Row><Col>
				<div className="OccupantText">
					<h5>Occupant Text</h5>
				{this.state.text[0].occupant_text}
				</div>
		</Col></Row>
		</Card.Body></Card>
				<Card><Card.Body>
				<Row><Col>
				<div className="OwnerText">
					<h5>Owner Text</h5>
				{this.state.text[0].owner_text}
				</div>
				</Col></Row>
				</Card.Body></Card>
				<Card><Card.Body>
				<Row><Col>
				<div className="FullPreviewText">
					<h5>Cityscope Text</h5>
				<div className="content" dangerouslySetInnerHTML={{__html:this.state.text[0].full_preview_text}}></div>
				</div>
				</Col></Row>
				</Card.Body></Card>
				
							
				</div>
			}

			</div>
		</Col>
						</Row>
		}
		</div>
        );
    }
}